import React, { useEffect, useState,useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import ACCOUNT_API, { cancelCheckToken } from '../../../utilities/api/account'
import CHECKOUT_API from '../../../utilities/api/checkout'
import TextField from '../../shared/form/textfield'
import PaymentOptions, { NEW_CREDIT_CARD, PAYPAL, SAVED_CREDIT_CARD } from '../../shared/paymentoptions'
import { getInitialCountryValue } from '../../shared/form/validation'
import {
  setDataToGoogle
} from '../../../utilities/function/common'

import {
  getCartToken,
  removeToken,
} from '../../../utilities/function/cartToken'

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse,
  isResponseCancelled,
} from '../../../utilities/function/apiResponse'

import {
  requiredFieldValidation,
  countryFieldValidation
} from '../../shared/form/validation'

import Loading from '../../shared/loading'
import {
  updateFinished,
  updatePopupNotification
} from '../../../app/action'
import Dropdown from '../../shared/form/dropdown'
import AddressField from '../../shared/form/textfield/address'
import globalCookies from '../../../utilities/function/cookies'
import {useAccount} from "../../../utilities/function/checkout";

let PaymentForm = (props) => {
  const { handleSubmit, checkToken, form, dispatch } = props
  const {getUser,accountStatus,initAccount,renderBillingInfo} = useAccount(checkToken)
  useEffect(() => {
    initAccount()
  }, [initAccount])
  const renderBillingFields = () => {
    const phoneType = getInitialCountryValue()
    return (
      <div className={'of-checkout-payment-form__billing'}>
        <div className={'of-checkout-payment-form__heading'}>Billing Details</div>
        <div className={'of-checkout-payment-form__main'}>
          <div className={'of-checkout-form__row'}>
            <div className={'of-checkout-form__column of-checkout-form__column--full'}>
              <Field label={'Address'}
                     component={AddressField}
                     name={'address'}
                     placeholder={'Street Address'}
                     validate={[requiredFieldValidation]}/>
            </div>
          </div>
          <div className={'of-checkout-form__row'}>
            <div className={'of-checkout-form__column'}>
              <Field label={'City'}
                     component={TextField}
                     name={'city'}
                     placeholder={'City'}
                     validate={[requiredFieldValidation]}/>
            </div>
            <div className={'of-checkout-form__column'}>
              <Field label={'State'} component={TextField} name={'state'} placeholder={'State'}
                     validate={[requiredFieldValidation]}/>
            </div>
          </div>
          <div className={'of-checkout-form__row'}>
            <div className={'of-checkout-form__column'}>
              <Field label={'Postcode'} component={TextField} name={'postcode'} placeholder={'Postcode'}
                     validate={[requiredFieldValidation]}/>
            </div>
            <div className={'of-checkout-form__column'}>
              <Field component={Dropdown} list={[
                {
                  label: 'Australia',
                  value: 'AU'
                },
                {
                  label: 'New Zealand',
                  value: 'NZ'
                }
              ]} name={'country'} initialValue={phoneType} label={'Country'} placeholder={'Country'}
                     validate={[requiredFieldValidation, countryFieldValidation]}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
  const renderBillingSection = () => {
    if (checkToken && checkToken.status === 'success') {
      return (
        renderBillingInfo()
      )
    }
    return (renderBillingFields())
  }
  if(checkToken.status!=="loading"){
    return (
      <>
        <form onSubmit={handleSubmit} className={'of-checkout-payment-form of-checkout-form'} >
          <div className={'of-checkout-payment-form__wrapper'}>
            {renderBillingSection()}
            <PaymentOptions
              getUser={getUser}
              form={form}
              dispatch={dispatch}
              store_cc={true}
            />
          </div>
        </form>
        {accountStatus === 'loading' ? <Loading wrapper={true}/> : <></>}
      </>
    )
  }
  return (<></>)
}
PaymentForm.propTypes = {
  handleSubmit: PropTypes.func,
  checkTokenStatus: PropTypes.string,
  history: PropTypes.any,
  form: PropTypes.any,
  dispatch: PropTypes.any,
  location: PropTypes.any,
  checkToken: PropTypes.any
}
PaymentForm = withRouter(PaymentForm)
PaymentForm = reduxForm({
  form: 'PaymentForm'
})(PaymentForm)

let Payment = (props) => {
  const {
    Form,
    cartStatus,
    cartData,
    finished,
    configurations
  } = useSelector(state => ({
    Form: state.form.PaymentForm,
    cartStatus: state.app.cartStatus,
    cartData: state.app.cartData,
    finished: state.app.finished,
    configurations: state.app.configurations
  }))
  const createAccount = localStorage.getItem('createAccount')
  const { history } = props
  const [checkToken, setCheckToken] = useState({})
  const [formRequest, setFormRequest] = useState({})
  const timeout = useRef(null)
  const handlePaymentForm = (paymentPayload, dispatch) => {
    const isApplyCredit = () => {
      if (Form && Form.values) {
        const { applyCredit } = Form.values
        return applyCredit
      }
      return false
    }
    const { address, country, postcode, state, city, payment_option, cc_id } = paymentPayload
    const cartToken = getCartToken()
    const createOrderAndPayInvoice = () => {
      const getPayInvoicePayload = () => {
        let payload = {
          payment_option,
        }
        if (payment_option === NEW_CREDIT_CARD) {
          const { card_number, card_type, card_cvv, card_date, card_holder_name, store_cc } = paymentPayload
          let cardDateObj = card_date ? card_date.split('/') : null
          if(cardDateObj){
            payload = {
              ...payload,
              card_number,
              card_type,
              card_cvv,
              card_holder_name,
              card_month: cardDateObj[0],
              card_year: cardDateObj[1],
              payment_option,
              store_cc
            }
          }

        } else if (payment_option === SAVED_CREDIT_CARD && cc_id) {
          payload = {
            ...payload,
            cc_id
          }
        }
        return payload
      }
      if (formRequest.status !== 'loading') {
        setFormRequest({
          ...formRequest,
          status: 'loading'
        })
      }
      if(timeout.current){
        window.clearTimeout(timeout.current)
      }
      const payInvoicePayload = getPayInvoicePayload()
      CHECKOUT_API.createOrder(payInvoicePayload, cartToken, isApplyCredit()).then((successresponse) => {
        const data = getDataFromSuccessResponse(successresponse)
        const { invoice_id, order_id, manual_review } = data
        const cart_token = getCartToken()
        const newFinished = {
          ...finished,
          payInvoicePayload,
          invoice_id,
          order_id,
          cart_token,
          manual_review
        }
        updateFinished(dispatch, newFinished)
        removeToken()
        localStorage.removeItem('createAccount')
        setDataToGoogle(cartData,invoice_id,configurations)
        timeout.current = window.setTimeout(() => {
          if(payment_option===PAYPAL){
            if(data && data.url){
              window.location.href = data.url
            }else{
              history.push(`${history.location.pathname}?a=checkout&step=finished`)
            }
          }else{
            history.push(`${history.location.pathname}?a=checkout&step=finished`)
          }
        }, 500)
      }, errorCreateOrder => {
        const error = getErrorFromFailResponse(errorCreateOrder)
        updatePopupNotification(dispatch, {
          status: 'error',
          error
        })
        setFormRequest({
          ...formRequest,
          status: undefined
        })
        if(error.data && error.data.data){
          const {order_id,invoice_id} = error.data.data
          if(order_id && invoice_id){
            removeToken()
            history.push(`${history.location.pathname}?a=checkout&step=payinvoice&invoice_id=${invoice_id}&order_id=${order_id}`)
          }
        }
      })
    }
    if (checkToken.status === 'success') {
      createOrderAndPayInvoice()
    } else {
      if (createAccount) {
        const createAccountPayload = JSON.parse(createAccount)
        let registerPayload = {
          ...createAccountPayload,
          address,
          country,
          postcode,
          state,
          city
        }
        if(globalCookies.get('referral_code')){
          registerPayload['referral_code'] = globalCookies.get('referral_code')
        }
        setFormRequest({
          ...formRequest,
          status: 'loading'
        })
        ACCOUNT_API.checkToken().then(()=>{
          createOrderAndPayInvoice()
        },()=>{
          ACCOUNT_API.register(cartToken, registerPayload).then(successCreateAccount => {
            const successCreateAccountResponse = getDataFromSuccessResponse(successCreateAccount)
            const { attributes } = successCreateAccountResponse
            const { token } = attributes
            ACCOUNT_API.setAccessToken(token)
            createOrderAndPayInvoice()
          }, errorCreateAccount => {
            const error = getErrorFromFailResponse(errorCreateAccount)
            setFormRequest({
              ...formRequest,
              status: 'error',
              error
            })
            updatePopupNotification(dispatch, {
              status: 'error',
              error,
              data: null
            })
          })
        })
      } else {
        history.push(`${history.location.pathname}?a=checkout&step=account`)
      }
    }
  }
  const dispatch = useDispatch()
  useEffect(() => {
    if (checkToken.status === undefined) {
      setCheckToken({
        ...checkToken,
        status: 'loading'
      })
      if (cancelCheckToken) {
        cancelCheckToken()
      }
      ACCOUNT_API.checkToken().then(successresponse => {
        localStorage.removeItem('createAccount')
        const data = getDataFromSuccessResponse(successresponse)
        setCheckToken({
          ...checkToken,
          status: 'success',
          data
        })
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        if (!isResponseCancelled(error)) {
          setCheckToken({
            ...checkToken,
            status: 'error',
            error
          })
          if (!localStorage.getItem('createAccount')) {
            updatePopupNotification(dispatch, {
              status: 'error',
              error
            })
            history.push(`${history.location.pathname}?a=checkout&step=account`)
          }
        }
      })
    }
  }, [history, checkToken, dispatch])
  useEffect(() => {
    if (cartStatus === 'error') {
      history.push(history.location.pathname)
    }
    if (cartStatus === 'success' && cartData && cartData.items.length === 0) {
      history.push(history.location.pathname)
    }
  }, [cartStatus, history, cartData])
  const renderMain = () => {
    return (<>
      <PaymentForm onSubmit={handlePaymentForm} checkToken={checkToken} formRequest={formRequest}
                   setFormRequest={setFormRequest}/>
    </>)
  }
  return (
    <>
      <div className='of-checkout-payment clearfix'>
        {renderMain()}
        {checkToken.status === 'loading' || formRequest.status === 'loading' ? <Loading
          className={'of-checkout-payment__loading'} wrapper={true}/> : <></>}
      </div>
    </>
  )
}
Payment.propTypes = {
  history: PropTypes.any
}
Payment = withRouter(Payment)

export default Payment